module.exports = __webpack_public_path__ + "static/media/FLR_Wallpaper01_1600x1200.6804e423.jpg";